import { COLLECTION_NAME } from ".";
import { storyConverter } from "db/converters";
import { useFetchByIds, useFetchPublic } from "@/services/common";

/**
 * Hook personalizado para obtener historias basadas en una lista de IDs.
 * Este hook realiza una consulta a la colección de historias
 * y devuelve las historias correspondientes.
 * @param {Array} storyIds - Lista de IDs de historias a buscar.
 * @returns {Object} - Un objeto que contiene:
 * - `stories`: Un array de historias obtenidas.
 * - `loading`: Un booleano que indica si la consulta está en curso.
 * - `error`: Un objeto de error si ocurrió un problema durante la consulta.
 */
export const useFetchStoriesByIds = (storyIds = []) => {
  const { data, loading, error } = useFetchByIds(
    COLLECTION_NAME,
    storyIds,
    storyConverter
  );

  return { stories: data, loading, error };
};

export const useFetchPublicStories = () => {
  const { data, loading, error } = useFetchPublic(
    COLLECTION_NAME,
    storyConverter
  );

  return {
    stories: data,
    loading,
    error,
  };
};
